import PageHeader from '@components/common/PageHeader';
import SeasonHeader from '@components/page/Farmland/SeasonHeader';
import { useParams } from 'react-router-dom';
import FarmlandList from '@components/page/Farmland/FarmlandList';
import { useEffect, useRef, useState } from 'react';
import FarmlandMap, {
    SelectFeature,
} from '@components/page/Farmland/FarmlandMap';
import FarmlandAdd from '@components/page/Farmland/FarmlandAdd'; // 추가
import { Alert } from '@utils/alert';
import { FarmlandListItem } from '@/api/growth/farmland/type';
import FarmlandDetail from '@components/page/Farmland/FarmlandDetail';

const Farmland = () => {
    const { gsIdx } = useParams<{ gsIdx?: string }>();
    const paramIdx = gsIdx ? Number(gsIdx) : undefined;
    const [_gsIdx, _setGsIdx] = useState(paramIdx);
    const [selectedFeature, setSelectedFeature] =
        useState<SelectFeature | null>(null);
    const [showFarmlandAdd, setShowFarmlandAdd] = useState(false);
    const [showFarmlandDetail, setShowFarmlandDetail] = useState(false);
    const [refreshKey, setRefreshKey] = useState(0);
    const [selectedCoords, setSelectedCoords] = useState<{
        lat: number;
        lon: number;
        gfIdx: number;
    } | null>(null);
    const currentGsIdxRef = useRef(_gsIdx);
    const currentGfIdxRef = useRef(0);

    // _gsIdx가 변경될 때마다 ref 업데이트
    useEffect(() => {
        currentGsIdxRef.current = _gsIdx;
    }, [_gsIdx]);

    const onChangeIdx = (gsIdx: number) => {
        _setGsIdx(gsIdx);
    };

    // 지적도 선택 시 호출되는 핸들러
    const handleFeatureSelect = async (
        feature: SelectFeature | null,
        gfIdx?: number,
    ) => {
        const currentGsIdx = currentGsIdxRef.current; // 최신값 사용
        console.log('현재 _gsIdx : ' + currentGsIdx);

        if (currentGsIdx === undefined || currentGsIdx === null) {
            await Alert.alert(
                '먼저 작기를 선택해주세요.',
                '우측상단 "작기선택" 버튼을 눌러주세요.',
                () => {
                    return;
                },
            );
        } else {
            console.log('선택된 지적도 정보:', feature);

            if (feature) {
                // 선택된 정보 상태에 저장하고 FarmlandAdd 모달 열기
                setSelectedFeature(feature);
                if (gfIdx) {
                    // 수정
                    setShowFarmlandDetail(true);
                    setShowFarmlandAdd(false);
                    currentGfIdxRef.current = gfIdx;
                } else {
                    // 등록
                    setShowFarmlandAdd(true);
                    setShowFarmlandDetail(false);
                    currentGfIdxRef.current = 0;
                }
            }
        }
    };

    // FarmlandAdd 모달을 닫는 핸들러
    const handleCloseFarmlandAdd = () => {
        setShowFarmlandAdd(false);
        setShowFarmlandDetail(false);
        setSelectedFeature(null);
    };

    // 등록 완료 후 호출되는 핸들러
    const handleFarmlandAddSuccess = () => {
        setShowFarmlandAdd(false);
        setShowFarmlandDetail(false);
        setSelectedFeature(null);
        // 리스트 갱신을 위해 refreshKey 증가
        setRefreshKey(prev => prev + 1);
    };

    const handleClickRow = (row?: FarmlandListItem) => {
        if (row) {
            setSelectedCoords({
                lat: Number(row.lat),
                lon: Number(row.lon),
                gfIdx: row.gfIdx,
            });
        } else {
            setSelectedCoords(null);
        }
    };

    const handleEditRow = (gfIdx: number) => {
        console.log(gfIdx);
        // 수정
        setShowFarmlandDetail(true);
        setShowFarmlandAdd(false);
        currentGfIdxRef.current = gfIdx;
    };

    return (
        <>
            <PageHeader
                title="생육농지 관리"
                breadcrumbs={[
                    { label: '홈', href: '/' },
                    { label: '생육관리' },
                    { label: '생육농지 관리', active: true },
                ]}
            />

            <SeasonHeader gsIdx={_gsIdx} onChangeIdx={onChangeIdx} />

            <div className="row">
                <div className="col-12 col-md-6">
                    <FarmlandMap
                        key={`${_gsIdx}-${refreshKey}`}
                        gsIdx={_gsIdx}
                        onFeatureSelect={handleFeatureSelect}
                        selectedCoords={selectedCoords}
                    />
                </div>
                <div className="col-12 col-md-6">
                    <FarmlandList
                        key={`${_gsIdx}-${refreshKey}`}
                        gsIdx={_gsIdx}
                        onClickRow={handleClickRow}
                        onEditRow={handleEditRow}
                        onSuccess={handleFarmlandAddSuccess}
                    />
                </div>
            </div>

            {/* FarmlandAdd 모달 조건부 렌더링 */}
            {showFarmlandAdd && selectedFeature && currentGsIdxRef.current && (
                <FarmlandAdd
                    gsIdx={currentGsIdxRef.current}
                    address={selectedFeature.address}
                    area={selectedFeature.area}
                    lat={selectedFeature.lat}
                    lon={selectedFeature.lng}
                    jimok={selectedFeature.jimok}
                    onClose={handleCloseFarmlandAdd}
                    onSuccess={handleFarmlandAddSuccess}
                />
            )}

            {showFarmlandDetail && currentGfIdxRef.current && (
                <FarmlandDetail
                    gfIdx={currentGfIdxRef.current}
                    onClose={handleCloseFarmlandAdd}
                    onSuccess={handleFarmlandAddSuccess}
                />
            )}
        </>
    );
};

export default Farmland;
